import React, {Component} from "react"

import Hero from "./Hero"
import AddList from "./AddList"

class HomePage extends Component{
	constructor() {
		super()
		this.state = []
	}

	render () {
		return (
			<div>
				<Hero />
				<AddList />
			</div>
		)
	}
}

export default HomePage